import React, { Component } from 'react';
import { Grid, Form, Button, Segment, Header, Message, Image } from 'semantic-ui-react';
import { login, loadConfig, loadHoldList, forgotPassword } from '../utils/rest';
import * as consts from '../static/constants';
import Loading from '../ui/Loading';
import { withRouter } from 'react-router-dom';

class Password extends Component {

  constructor(props) {
    super(props);
    this.state = {
      password: '',
      showError: false,
      errorMsg: this.props.t("incorrect.login"),
      loading: false,
      open: false,
      showErrorColor: "red"
    }
  }

  onChange = (e) => {
    this.setState({
      [e.target.name]: e.target.value
    })
  }

  handleSubmit = (e) => {
    e.preventDefault()
    const { history } = this.props;
    if(this.props.location.state !== undefined && this.props.location.state.email !== ""){
        if (this.state.password !== "") {
            const loginRequest = {
              "username": this.props.location.state.email,
              "password": this.state.password
            }
            this.setState({
              loading: true
            })
            login(loginRequest)
              .then(response => {
                if (response != null) {
                  localStorage.setItem(consts.ACCESS_TOKEN, response);
                  history.push("/home");
                } else {
                  this.setState({
                    showError: true,
                    loading: false,
                    showErrorColor: "red"
                  });
                }
              }).catch(error => {
                if (error !== null && typeof error.response !== 'undefined') {
                  this.setState({
                    errorMsg: error.response.data,
                    showError: true,
                    loading: false,
                    showErrorColor: "red"
                  });
                } else {
                  this.setState({
                    errorMsg: this.props.t("timeout"),
                    showError: true,
                    loading: false,
                    showErrorColor: "red"
                  });
                }
              });
          }
    }else{
        history.push("/");
    }
  }

  componentDidMount() {
    this.loadConfigOnce();
    let paramsString = this.props.location.search;
    if (paramsString.length > 0) {
      const params = new URLSearchParams(paramsString);
      const r = params.get('r');
      this.setState({
        errorMsg: r === "password" ? this.props.t("new.credentials") : r === "expired" ? this.props.t("expired") : r === "texpired" ? this.props.t("texpired") : r,
        showError: true,
        loading: false,
        showErrorColor: "red"
      });
    }
  }

  loadConfigOnce = () => {
    //if (Object.keys(this.props.config).length === 0) {
    loadConfig().then((response) => {
      this.props.addToConfig(response);
      localStorage.setItem("config", JSON.stringify(response));
    });
    let holdReason = [];
    loadHoldList().then((response) => {
      if (response != null) {
        let hold = Object.keys(response);
        hold.map((item, index) => {
          holdReason.push({
            key: index + 1, text: item, value: item
          });
          return item;
        })
      }
      this.props.addItem("holdReason", holdReason);
    });
    //}
  }

  handleResetPasswordLink = (e) => {
    e.preventDefault();
    if (this.props.location.state.email.length > 0) {
      forgotPassword({}, {
        user: this.props.location.state.email
      }).then(response => {
        if (response !== null) {
          this.setState({
            errorMsg: response,
            showError: true,
            loading: false,
            showErrorColor: "green"
          });
        }
      });
    } else {
      this.setState({
        errorMsg: this.props.t("username.required"),
        showError: true,
        loading: false,
        showErrorColor: "red"
      });
    }
  }

  backToLogin = (e) => {
    e.preventDefault()
    this.props.history.push("/")
  }

  render() {
    let showError;
    if (this.state.showError) {
      showError = (
        <Message className="small" color={this.state.showErrorColor}>
          {this.state.errorMsg}
        </Message>
      );
    }
    if (this.state.loading) {
      return (
        <Loading />
      )
    }
    return (
      <div>
        <Grid className="center aligned" >
          <Grid.Column width={5} />
          <Grid.Column width={6} style={{ marginTop: "150px" }}>
            <Header as="h2" className="login-version" >
              <div className="content">
                <Image style={{ maxHeight: 100, maxWidth: 300 }} src={(this.props.config.LOGIN_LOGO ? this.props.config.LOGIN_LOGO : "")} alt="" />
                {this.props.t("app.name")}
                <span className="version-txt"> {this.props.config.version} </span>
              </div>
            </Header>
            <Form className="large">
              <Segment>
                <Form.Input icon='lock' required={true} iconPosition='left' type="password" name="password" onChange={this.onChange} placeholder={this.props.t("password")} value={this.state.password} />
                <Button type="submit" onClick={this.handleSubmit} size="large" className="fluid grey">{this.props.t("login")}</Button>
                    <p className="textright link resetlinkBack"><a onClick={this.backToLogin}>Back</a></p>
                    <p className="textright link resetlink"><a onClick={this.handleResetPasswordLink}>{this.props.t("forgot.password")}</a></p>
              </Segment>
            </Form>
            {showError}
            <Message className="small">
              {this.props.t("need.help")} <a href="" dangerouslySetInnerHTML={{ __html: this.props.config.AGENCY_SUPPORT_NUMBER }}></a><br />
              {this.props.config.LOGIN_TEXT}
            </Message>
          </Grid.Column>
          <Grid.Column width={5} />
        </Grid>
      </div>
    );
  }
}
export default withRouter(Password);


// WEBPACK FOOTER //
// ./src/app/login/Password.js